import { useFacetContext, useRouterContext } from '../../../context/PlpContext';
import { useExperiencesContext } from '../../experiences/Experiences';

export const useFilterDrawerData = () => {
  const facetContext = useFacetContext();
  const { isTabletEnhancementsFlagOn } = useExperiencesContext();
  const { baseFacetId, applied } = facetContext;

  const router = useRouterContext();

  return {
    experiencesContext: {
      isTabletEnhancementsFlagOn,
    },
    facetContext: {
      applied,
      baseFacetId,
    },
    router,
  };
};
